<template>
  <div>
    <h1 class="mdn-Heading mdn-Heading--sm">Tipos de Solicitação</h1>

    <SGPBotaoAdicionarNovoComponent @sgpAdiconarNovoEmit="adicionarNovo" />

      <SGPTabelaComponent
        v-if="listaDeTiposSolicitacao && listaDeTiposSolicitacao.length"
        :colunas="colunas"
        :dados="listaDeTiposSolicitacao"
        :key="listaDeTiposSolicitacao.length"
        @sgpTabelaLinhasSelecionadasEmit="gerenciadorDeSelecionados"
        @sgpTabelaEditarSelecionadoEmit="editarSelecionado"
        @sgpTabelaDeletarSelecionadoEmit="deletarSelecionado"
        selecionarColunas
      >
      </SGPTabelaComponent>
    <SGPAlertaComponent v-else></SGPAlertaComponent>

    <SGPModalComponent
      v-if="abrirModal"
      tamanho="sm"
      titulo="Tipos de Solicitação"
      @sgpModalFechar="fecharModal"
      :mostrarFooter="false"
    >
      <FormularioCtrlTipoSolicitacaoComponent
        :tipoFormulario="tipoFormulario"
        :ctrlTipoSolicitacao="ctrlTipoSolicitacao"
        @fechar="fecharModal"
        @atualizarListagemTabela="aplicarFiltros"
      />
    </SGPModalComponent> 
    
    <SGPConfirmacaoDelecaoComponent
      v-if="deletarDados"
      @sgpCancelarDelecaoEmit="cancelarDelecao()"
      @sgpConfirmarDelecaoEmit="confirmarDelecao()"
    />
    
    <SGPLoadingComponent v-if="loadingTiposSolicitacao"/>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import FormularioCtrlTipoSolicitacaoComponent from '../components/FormularioCtrlTipoSolicitacaoComponent.vue'

export default {
  components: { FormularioCtrlTipoSolicitacaoComponent },
  name: 'CtrlTipoSolicitacaoPage',

  data () {
    return {
      mostrarSelecionar: true,
      mostrarEditar: true,
      mostrarDeletar: true,
      linhasSelecionadas: [],
      abrirModal: false,
      deletarDados: false,
      tipoFormulario: 'salvar',
      ctrlTipoSolicitacao: {},
    }
  },
  created () {
    this.listarTiposSolicitacao();
  },
  computed: {
    ...mapGetters('ctrlTipoSolicitacao', ['listaDeTiposSolicitacao','loadingTiposSolicitacao']),

    colunas () {
      return [
        { key: 'selecionar', label: '', sortable: false },
        { key: 'nome', label: 'Nome', sortable: true },
        { key: 'descricao', label: 'Descrição', sortable: false },
      ]
    }
  },

  methods: {
    ...mapActions('ctrlTipoSolicitacao', 
    [
      'listarTiposSolicitacao',
      'excluirTipoSolicitacao',
    ]),

    gerenciadorDeSelecionados (selecionados) {
      this.linhasSelecionadas = selecionados;
    },

    editarSelecionado () {
      this.tipoFormulario = 'editar';
      this.ctrlTipoSolicitacao = this.linhasSelecionadas[0];
      this.abrirModal = true;
    },

    deletarSelecionado () {
      this.deletarDados = true;
    },

    cancelarDelecao () {
      this.deletarDados = false;
    },

    async confirmarDelecao () {
      await this.excluirTipoSolicitacao(this.linhasSelecionadas);
      this.deletarDados = false;
      await this.listarTiposSolicitacao();
    },

    adicionarNovo () {
      this.ctrlTipoSolicitacao = {};
      this.tipoFormulario = 'salvar';
      this.abrirModal = true;
    },

    fecharModal () {
      this.abrirModal = false;
    },

    aplicarFiltros() {
      this.listarTiposSolicitacao();
    },
  }
}
</script>
